import { render, staticRenderFns } from "./NoComissionPay.vue?vue&type=template&id=d8c87ca2&scoped=true"
import script from "./NoComissionPay.vue?vue&type=script&lang=js"
export * from "./NoComissionPay.vue?vue&type=script&lang=js"
import style0 from "./NoComissionPay.vue?vue&type=style&index=0&id=d8c87ca2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c87ca2",
  null
  
)

export default component.exports